import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "../app/globals.css";
import { HumMidiStudio } from "../app/HumMidiStudio";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Native app root was not found.");
}

createRoot(root).render(
  <StrictMode>
    <HumMidiStudio />
  </StrictMode>,
);
